import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../Components/Navbar'
import Footer from '../Pages/Shared/Footer'
import NavCart from '../Components/NavCart'

const Main = () => {
  return (
    <div className='h-screen'>
      <Navbar></Navbar>
      {/* <NavCart></NavCart> */}
      <Outlet></Outlet>
      {/* <Footer></Footer>  */}
    </div>
  )
}

export default Main
